import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className", "content"];

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { Button } from '@flowio/react-button';
import React from 'react';
var style = {
  container: process.env.NODE_ENV === "production" ? {
    name: "akdqam",
    styles: "margin-top:1rem"
  } : {
    name: "o4obmu-container",
    styles: "margin-top:1rem;label:container;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0Jhbm5lckFjdGlvbi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBUWEiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvQmFubmVyQWN0aW9uLnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuXG5pbXBvcnQgeyBjc3MsIGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IEJ1dHRvbiB9IGZyb20gJ0BmbG93aW8vcmVhY3QtYnV0dG9uJztcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgdHlwZSB7IEJhbm5lckFjdGlvblByb3BzIH0gZnJvbSAnLi4vdHlwZXMnO1xuXG5jb25zdCBzdHlsZSA9IHtcbiAgY29udGFpbmVyOiBjc3Moe1xuICAgIG1hcmdpblRvcDogJzFyZW0nLFxuICB9KSxcbn07XG5cbmNvbnN0IEJhbm5lckFjdGlvbjogUmVhY3QuRkM8QmFubmVyQWN0aW9uUHJvcHM+ID0gKHtcbiAgY2hpbGRyZW4sXG4gIGNsYXNzTmFtZSxcbiAgY29udGVudCxcbiAgLi4udW5oYW5kbGVkUHJvcHNcbn0pID0+IChcbiAgPGRpdlxuICAgIHsuLi51bmhhbmRsZWRQcm9wc31cbiAgICBjbGFzc05hbWU9e2NsYXNzTmFtZX1cbiAgICBjc3M9e3N0eWxlLmNvbnRhaW5lcn0+XG4gICAgPEJ1dHRvbiB2YXJpYW50PVwib3V0bGluZVwiPlxuICAgICAge2NoaWxkcmVuICE9IG51bGwgPyBjaGlsZHJlbiA6IGNvbnRlbnR9XG4gICAgPC9CdXR0b24+XG4gIDwvZGl2PlxuKTtcblxuQmFubmVyQWN0aW9uLmRpc3BsYXlOYW1lID0gJ0Jhbm5lckFjdGlvbic7XG5cbmV4cG9ydCBkZWZhdWx0IEJhbm5lckFjdGlvbjtcbiJdfQ== */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }
};

var BannerAction = function BannerAction(_ref) {
  var children = _ref.children,
      className = _ref.className,
      content = _ref.content,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return jsx("div", _extends({}, unhandledProps, {
    className: className,
    css: style.container
  }), jsx(Button, {
    variant: "outline"
  }, children != null ? children : content));
};

BannerAction.displayName = 'BannerAction';
export default BannerAction;